<template>

	<div id="page" v-loading="loading" element-loading-text="匹配中,请稍等片刻" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(255,255,255,0.7)">

		<!-- 页头 -->
		<pagehead />

		<!-- 页面 -->
		<div class="pager">

			<!-- 上面 -->
			<el-container class="w1k2 mauto mt35 plr10 bw br5 usn">
				<el-main>
					<div class="flowBarBox df dfsb aic">
						<!-- 下载数据模板 -->
						<div class="flowBar" @click="download">
							<img class="img" src="../assets/bar-1.png">
							<div class="flowBarTxt">下载数据模板</div>
						</div>
						<!-- 下一条 -->
						<div class="flowBarNext"><img class="img" src="../assets/next.png"></div>
						<!-- 导入数据模板 -->
						<div class="flowBar" @click="upload">
							<el-upload class="upload-demo" ref="upload" :action="uploadUrl" :limit="1"
								:file-list="fileList" :data="data" :show-file-list="false" :before-upload="upload"
								:on-success="upload" :on-progress="upload" :disabled="disabled">
								<img class="img" src="../assets/bar-2.png">
								<div class="flowBarTxt">导入数据模板</div>
							</el-upload>
						</div>
						<!-- 下一条 -->
						<div class="flowBarNext"><img class="img" src="../assets/next.png"></div>

						<!-- 匹配数据 -->
						<div class="flowBar" @click="match">
							<img class="img" src="../assets/bar-3.png">
							<div class="flowBarTxt">匹配数据</div>
						</div>

						<!-- 下一条 -->
						<div class="flowBarNext"><img class="img" src="../assets/next.png"></div>

						<!-- 导出匹配数据 -->
						<div class="flowBar" @click="derive">
							<img class="img" src="../assets/bar-4.png">
							<div class="flowBarTxt">导出匹配数据</div>
						</div>
					</div>
				</el-main>
			</el-container>

			<!-- 下面表格 -->
			<el-container class="mauto mt30 mb30 plr20 pb60 w1k2 bw br5">
				<el-main>
					<!-- 表格 -->
					<div class="hocTable">
						<div class="tr">
							<div class="th">导入数量</div>
							<div class="th">匹配数量</div>
							<div class="th">未匹配数量</div>
						</div>
						<div class="tr">
							<!-- <div class="td">1</div> -->
							<!-- 导入数量 -->
							<div class="td">{{allCount ? allCount : '0'}}</div>
							<!-- 匹配数量 -->
							<div class="td">{{mappingCounts ? mappingCounts : '0'}}</div>
							<!-- 未匹配数量 -->
							<div class="td">{{noMappingCounts ? noMappingCounts : '0'}}</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</div>

		<el-dialog title="提示" :visible.sync="flowAlert" width="30%">
			<!-- <el-dialog title="提示" :visible.sync="flowAlert" width="30%" :before-close="handleClose"> -->
			<div class="flowAlert plr30">{{hint}}</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="flowAlert = false">取 消</el-button>
				<el-button type="primary" @click="discard">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 页脚 -->
		<pagefoot />

		<!-- logo加载动画 -->
		<div :class=" loading ? 'loadingLogo active' : 'loadingLogo'" v-if="loading">
			<img src="../assets/logo2.png">
		</div>

	</div>
</template>
<script>
	// 全局变量
	var that;
	// 定时器
	var time;
	export default {
		// 页面变量
		data() {
			return {
				// 进度
				flow: 1,
				// 上传路劲
				uploadUrl: "",
				// 流程弹窗
				flowAlert: false,
				// 文件列表
				fileList: [],
				// 是否禁用文件上传
				disabled: true,
				// 是否加载
				loading: false,
				// 导入数据
				allCount: '',
				// 匹配数
				mappingCounts: '',
				// 未匹配数
				noMappingCounts: '',
				// 提示语
				tips: '',
				// 弹窗提示语
				hint: '',
			}
		},

		// 实例化后
		created() {

			that = this;

			// 上传路径
			that.uploadUrl = that.util.config.host + "/api/Organization/insertListTemplate";

		},

		//	激活
		activated() {

			//	检测登录
			that.util.checkToken((res) => {

				// 获取后台应该执行的进度
				that.getState();

			});

		},

		//
		computed: {

			//	设置上传token
			data() {
				return {
					"token": localStorage.getItem("token"),
					"mmpMemberId": localStorage.getItem('memberId'),
				}
			},

		},

		// 实例化销毁
		destroyed() {
			// 清除定时器
			clearInterval(time);
		},


		// 方法集
		methods: {

			// 获取表格信息
			/* 这里执行了两次*/
			getTable(e) {
				// 请求接口
				that.request({
					url: '/api/MemberMapping/mappingResult',
					// 上传数据
					data: {
						// 表id
						mmpMemberMappingId: localStorage.getItem('dataId'),
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 判断传进来的需要
							if (e == 1) {
								// 导入数据
								that.allCount = rs.data.allCount;
								// 匹配数
								that.mappingCounts = 0;
								// 未匹配数
								that.noMappingCounts = 0;
							} else {
								// 导入数据
								that.allCount = rs.data.allCount;
								// 匹配数
								that.mappingCounts = rs.data.mappingCounts;
								// 未匹配数
								that.noMappingCounts = rs.data.noMappingCounts;
							};
              if (that.allCount>0) {
                that.hint = '当前已有数据导入，是否要覆盖本次数据重新上传？';
              }
						}

						return;
					}
				})

			},

			// 下载数据模板
			download() {

				// 新开页面（ 网址 接口 用户token ）
				// window.open(that.util.config.host + "/api/mapping/downloadFile?token=" + localStorage.getItem("token"));
        window.location.href=that.util.config.host + "/api/mapping/downloadFile?token=" + localStorage.getItem("token")
			},

			//	上传组件成功回调
			upload(response, file, fileList) {

				// 判断是否禁用
				if (that.disabled) {
					// 打开废弃弹窗
					that.flowAlert = true;
					return;
				};

				// 判断e是否等于1
				if (localStorage.getItem('flow') != 1 || localStorage.getItem('flow') != 3) {

					// 判断进度
					that.ifFlow(1)
				};


				//	当上传组件被点击时触发
				if (response.type == "click") {

				};

				//	上传前方法
				if (file == undefined && fileList == undefined && response && response.name) {

					if (!response.name.split('.')[1] === 'xls' && !response.name.split('.')[1] === 'xlsx') {
						that.$message.warning('上传文件只能是 xls、xlsx格式!')
						return
					}

					//	返回false不会自动上传
					return true;

				};

				//	上传中方法
				if (file != undefined && fileList != undefined && response.type == "progress") {
					// 打开加载动画
					that.util.showLoading();

				};

				//	上传成功
				if (response.code) {

					// 关闭加载动画
					that.util.hideLoading();

					// 判断返回的参数
					if (response.code == 200) {

						// 弹窗提示用户
						that.$message.success('上传成功');

						// 赋值会员情况表ID
						localStorage.setItem('dataId', response.data);

						// 清空文件列表
						that.fileList = [];

						// 禁用
						that.disabled = true;

						// 设置进度
						that.setFlow(2);

						// 获取列表信息
						that.getTable(1);

					} else {

						// 弹窗提示用户
						that.$message.error(response.msg);

						// 清空文件列表
						that.fileList = [];

					}
				}
			},

			// 匹配数据
			match() {

				// 判断进度
				if (!that.ifFlow(2)) {
					return;
				};

				// 请求接口
				that.request({
					url: '/api/MemberMapping/mappingYcode',
					// 上传数据
					data: {
						// 会员匹配情况表ID
						mmpMemberMappingId: localStorage.getItem('dataId'),
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 判断当前路径
							if (that.$route.path == '/hoc') {
								//弹窗提示用户
								that.$message.success('您的文档已进入排队序列，请稍等片刻');
							};

							// 开启进度条
							that.loading = false;

							// 设置进度
							that.setFlow(3);

							// 获取列表
							that.getTable(1);

							// 判断有无计时器
							if (time) {
								clearInterval(time);
							};

							// 设置定时器
							time = setInterval(() => {


								that.getState(1);

							}, 10000);

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 导出数据
			derive() {
				// 打开文件上传
				that.disabled = false;

				// 判断进度
				if (!that.ifFlow(3)) {
					return;
				}

				var host = that.util.config.host

				var url = "/api/Organization/exportMapping?mmpMemberMappingId=" + localStorage
					.getItem('dataId') + '&token=' + localStorage.getItem("token");

				// 请求接口
				that.request({
					url: url,
					method: "get",
					// 调用成功
					success(rs) {
						// 判断返回值
						if (rs.code) {
							// 新建变量
							var msg = '';
							// 编辑弹窗信息
							if (rs.code == 801) {
								msg = '接口配置错误';
							} else if (rs.code == 802) {
								msg = '会员接口配置错误';
							} else if (rs.code == 803) {
								msg = '接口返回类型不可以以返回条数计费';
							} else if (rs.code == 804) {
								msg = '费用不足';
							} else if (rs.code == 805) {
								msg = '会员接口调用次数达到日限制';
							} else if (rs.code == 806) {
								msg = '切面时，接口返回值转换错误';
							} else if (rs.code == 807) {
								msg = '接口调用频率异常';
							};
							// 弹窗提示
							that.$message.error(msg);
						} else {
              window.location.href=host + url
							// window.open();
						}
					}
				})

			},

			// 废弃匹配
			discard() {
				// 关闭弹窗
				that.flowAlert = false;
				// 请求接口
				that.request({
					url: '/api/MemberMapping/updateMmpMemberMappingDiscard',
					// 上传数据
					data: {
						// 会员匹配情况表的id
						memberId: localStorage.getItem('memberId'),
					},
					// 打开弹窗
					load: true,
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							//弹窗提示用户
							that.$message.success('废弃成功');

							// 编辑提示语
							that.hint = '当前已有数据导入，是否要覆盖本次数据重新上传？';

							// 设置进度
							that.setFlow(1);

							// 清空数据
							// 导入数据
							that.allCount = 0;
							// 匹配数
							that.mappingCounts = 0;
							// 未匹配数
							that.noMappingCounts = 0;

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},



			// 获取匹配状态
			getState(type) {

				// 请求接口
				that.request({
					url: '/api/MemberMapping/selectMmpMemberMappingById',
					// 上传数据
					data: {
						// 会员匹配情况表的id
						memberId: localStorage.getItem('memberId'),
					},
					// 是否开启加载
					// load: true,
					// 调用成功
					success(rs) {

						// 返回成功
						if (rs.code == 200) {

							// 判断有无data
							if (!rs.data) {

								// 关闭上传禁用
								that.disabled = false;

								return;
							};

							// 缓存id
							localStorage.setItem('dataId', rs.data.id);

							// 判断有无计时器
							if (time) {
								clearInterval(time);
							}

							// 判断有无传参类型
							if (type) {

								// 判断是否返回成功
								if (rs.data.isDiscard == 1) {

									// 弹窗提示用户
									that.$message.warning('已废弃当前匹配');

									// 关闭动画
									that.loading = false;

								} else if (rs.data.mappingStatus == 4 || 5) {

									// 关闭动画
									that.loading = false;

								};

							}

							// 是否废弃 0正常 1是废弃
							if (rs.data.isDiscard == 1) {

								// 弹窗提示用户
								that.$message.info({
									showClose: true,
									message: '您当前进度已废弃，请重新导入进行匹配',
								});

								// 重置进度
								that.setFlow(1);

								// 打开文件上传
								that.disabled = false;

								// 导入数据
								that.allCount = 0;
								// 匹配数
								that.mappingCounts = 0;
								// 未匹配数
								that.noMappingCounts = 0;

							} else {

								// 判断返回的文档进度
								if (rs.data.mappingStatus == 4) {

									// 关闭动画
									that.loading = false;

									// 弹窗提示用户
									that.$message.success('当前数据已匹配完成，导出匹配数据即可。');

									// 重置进度
									that.setFlow(3);

									// 编辑提示语
									that.hint = '当前数据已匹配完成可以直接下载，是否废弃重新导入匹配';

									// 关闭文件上传
									that.disabled = true;

									// 获取表格信息
									that.getTable();

								} else if (rs.data.mappingStatus == 5) {

									// 关闭动画
									that.loading = false;

									// 弹窗提示用户
									that.$message.success('当前数据已匹配完成，导出匹配数据即可。');

									// 重置进度
									that.setFlow(3);

									// 打开文件上传
									that.disabled = false;

									// 获取表格信息
									that.getTable();

								} else if (rs.data.mappingStatus == 2) {

									// 重置进度
									that.setFlow(2);

									// 编辑提示语
									that.hint = '当前已有数据导入，是否要覆盖本次数据重新上传？';

									// 关闭禁用
									that.disabled = true;

									// 匹配数据
									that.match();

								} else if (rs.data.mappingStatus == 3) {

									// 获取表格信息
									that.getTable(1);

									// 打开弹窗
									that.loading = false;

									// 设置定时器
									time = setInterval(() => {

										// 获取匹配状态
										that.getState(1);

									}, 10000);

								} else if (rs.data.mappingStatus == 1) {

									// 重置进度
									that.setFlow(2);

									// 获取表格信息
									that.getTable(1);

									// 编辑提示语
									that.hint = '当前已有数据导入，是否要覆盖本次数据重新上传？';

									// 关闭禁用
									that.disabled = true;
								};

							}

						}

					}
				});
			},

			// 判断进度选择弹窗
			ifFlow(e) {

				// 判断进度 返回真
				if (e == 1 && localStorage.getItem('flow') == 3) {
					return true;
				};

				// 判断是否大于传进来的参数
				if (localStorage.getItem('flow') < e) {

					// 判断当前进度 修改合适的提示语
					if (localStorage.getItem('flow') == 1) {
						if (e == 2) {
							that.tips = '请先下载数据模板'
						} else {
							that.tips = '当前无匹配完成的数据，无法导出。'
						}
					} else if (localStorage.getItem('flow') == 2) {
						that.tips = '请匹配数据'
					} else if (localStorage.getItem('flow') == 3) {
						that.tips = '当前无匹配完成的数据，无法导出。'
					}

					// 弹窗提示
					that.$message.warning(that.tips);
					return false;

				} else if (localStorage.getItem('flow') > e) {

					if (e == 2) {
						that.tips = '当前数据已匹配完成，导出匹配数据即可。';

						// 弹窗提示
						that.$message.warning(that.tips);

					} else if (e == 1) {
						// 判断进度
						if (localStorage.getItem('flow') == 3) {

							that.hint = '当前已有数据匹配完成，是否要覆盖本次数据重新上传？';

						} else {

							that.hint = '当前已有数据导入，是否要覆盖本次数据重新上传？';
						}

						// 调起确认弹窗
						that.flowAlert = true;
					}
					return false;

				};

				return true;

			},

			// 设置进度
			setFlow(e) {

				// 设置进度
				that.flow = e;
				localStorage.setItem('flow', e);

				// 判断当前第几步
				if (e == 1) {
					// 开启文件上传
					that.disabled = false;
				}

			},

		},
	};
</script>
<style>
	/* 流程块 */
	.flowBar {
		position: relative;
		width: 240px;
		height: 139px;
		cursor: pointer;
		transition: .5s;
	}

	/* 鼠标滑过流程块 */
	.flowBar:hover {
		transform: scale(1.03);
		box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, .13);
	}

	/* 刘成块文字 */
	.flowBarTxt {
		position: absolute;
		bottom: 15px;
		width: 100%;
		text-align: center;
		color: white;
	}

	/* 表格 */
	.hocTable {
		border: 1px solid #eee;
	}

	/* 第二行开始的行 */
	.hocTable .tr+.tr .td {
		border-top: 1px solid #eee;
	}

	/* 每一个单元格 */
	.hocTable .tr .th,
	.hocTable .tr .td {
		flex: 1;
		color: #666;
		font-size: 16px;
		text-align: center;
	}

	/* 表头 */
	.hocTable .tr .th {
		line-height: 40px;
		background-color: #E9F3FF;
	}

	/* 表格 */
	.hocTable .tr .td {
		line-height: 50px;
	}

	/* 确认流程弹窗 */
	.flowAlert {
		text-align: center;
		font-size: 16px;
		color: #000000;
	}


	.el-loading-mask {}

	/* 加载loading */
	.loadingLogo {
		position: absolute;
		top: 50%;
		left: 50%;
		opacity: 0;
		transition: .3s;
		/* element 加载高度为 2000 */
		z-index: 2001;
	}


	/* 加载loading  出现时 */
	.loadingLogo.active {
		opacity: 1;
	}

	/* 加载图 */
	.loadingLogo img {
		width: 204px;
		height: 167px;
		transform: translate(-50%, calc(-100% - 20px));
		user-select: none;
	}
</style>
